import { ref } from "@vue/composition-api"

export default function usePermission(id) {
  const valid = ref(false)
  const userData = JSON.parse(localStorage.getItem("userData"))

  const find = userData.permission.find((item) => item.id == id)

  if (find) valid.value = true
  else valid.value = false

  return {
    valid,
  }
}
